A human-readable error message describing why the position could not be synced.

For example, "Invalid job category code" or "Position location not found".
